import { Box, Stack, Typography } from "@mui/material";
import { useDealContext } from "../../deal/context";
import { AdvisorTitle } from "../components/AdvisorTitle";
import { OverviewBox } from "../../company/styles/AdvisorStyles";
import { Link } from "react-router-dom";
import { useAdvisor } from "../context/AdvisorContext";
import Loading from "../../../components/Loading";
import { RecentAdvisors } from "../components/RecentAdvisors";
import { OnboardingSetup } from "../components/OnboardingSetup";
import { useState, useEffect } from "react";
import { MeetingsSidebar } from "../components/MeetingsSidebar";
import { OnboardingSteps } from "../../landing/components/OnboardingSteps";
import { useAdvisorLedger } from "../hooks/useAdvisorLedger";

export const AdvisorHome = () => {
    const { dealContext } = useDealContext();
    const { advisor, loading, error, fetchAdvisor, updateAdvisor } = useAdvisor();
    const { ledger, loading: ledgerLoading, error: ledgerError } = useAdvisorLedger(
        advisor?.uuid ?? '',
        dealContext.project?.tag ?? ''
    );
    const project = dealContext.project;
    const viewerRole = dealContext.role;

    const [showOnboarding, setShowOnboarding] = useState(() => {
        const hasCompletedOnboarding = localStorage.getItem(`onboarding_completed_${project.tag}`);
        //return !hasCompletedOnboarding;
        return false;
    });

    useEffect(() => {
        const hasIntroMeeting = advisor?.meetings?.some((meeting: any) => meeting?.scheduler?.type === "intro");
        const hasDemoMeeting = advisor?.meetings?.some((meeting: any) => meeting?.scheduler?.type === "demo");
        if (hasIntroMeeting && hasDemoMeeting) {
            localStorage.setItem(`onboarding_completed_${project.tag}`, 'true');
        } else {
            localStorage.removeItem(`onboarding_completed_${project.tag}`);
        }
    }, [advisor, project.tag]);

    if (loading) {
        return <Loading />;
    }

    const validMeetings = advisor?.meetings?.filter((meeting: any) => meeting.status !== "cancelled" && meeting.scheduler?.type !== "onboarding");
    const upcomingMeetings = validMeetings?.filter((meeting: any) => new Date(meeting.event_start) > new Date());

    if (!advisor) {
        return <Loading />;
    }
    
    return (
        <Box>
            <AdvisorTitle project={project} section={`Help make ${project.name} more successful`} subheading="Give insight and get access - to equity opportunities, industry insight, and other top executives." />
            {showOnboarding && <OnboardingSetup />}
            <Stack spacing={2} direction="row" sx={{
                marginBottom: "20px",
                paddingBottom: "30px",
                position: "relative"
            }}>
                <OverviewBox className={`display-box white`} onClick={() => { }}>
                    <Typography variant="h5">
                        <Link to="feedback">{advisor?.viewpoints?.length}</Link>
                    </Typography>
                    <Typography variant="body2" color="textSecondary">Feedback Session{advisor?.viewpoints?.length === 1 ? "" : "s"}</Typography>
                    <Typography variant="body2" color="textSecondary"><Link to="feedback">View Your Responses &raquo;</Link></Typography>
                </OverviewBox>
                <OverviewBox className={`display-box white`} onClick={() => { }}>
                    <Typography variant="h5">
                        <Link to="meet">{validMeetings?.length}</Link>
                    </Typography>
                    <Typography variant="body2" color="textSecondary">Meeting{validMeetings?.length === 1 ? "" : "s"}</Typography>
                    <Typography variant="body2" color="textSecondary"><Link to="meet">Schedule a Meeting &raquo;</Link></Typography>
                </OverviewBox>
                <OverviewBox className={`display-box white`} onClick={() => { }}>
                    <Typography variant="h5">
                        <Link to="refer">0</Link>
                    </Typography>
                    <Typography variant="body2" color="textSecondary">Referrals</Typography>
                    <Typography variant="body2" color="textSecondary"><Link to="refer">Invite Colleagues &raquo;</Link></Typography>
                </OverviewBox>
                { (ledger?.length ?? 0) > 0 && <OverviewBox className={`display-box white highlighted`} onClick={() => { }} sx={{ backgroundColor: "#f0f6ff"}} >
                    <Typography variant="h5">
                        <Link to="shares">{ledger?.reduce((acc, curr) => acc + (curr.shares_earned ?? 0), 0)}</Link>
                    </Typography>
                    <Typography variant="body2" color="textSecondary">Advisor Shares Earned</Typography>
                    <Typography variant="body2" color="textSecondary"><Link to="shares">View Details &raquo;</Link></Typography>
                </OverviewBox> }
            </Stack>
            <Box sx={{ display: "flex", flexDirection: "row", gap: "40px" }}>
                <Box sx={{ flex: "1 1" }}>
                    <Box sx={{ marginBottom: "20px", borderBottom: "1px solid #ccc", paddingBottom: "20px" }}>
                        <h5>About {project.name}</h5>
                    </Box>
                    <p>{project.public_description}</p>
                    <Stack direction="column" spacing={1} sx={{ marginBottom: "40px" }}>
                        {project.company?.website && <Box><strong>Website:</strong> <a href={project.company?.website} target="_blank" rel="noopener noreferrer">{project.company?.website}</a></Box>}
                        {project.founder_name && <Box><strong>Founder:</strong> <a href={project.founder_link} target="_blank" rel="noopener noreferrer">{project.founder_name}</a></Box>}
                    </Stack>
                    <Box sx={{ marginBottom: "20px", borderBottom: "1px solid #ccc", paddingBottom: "20px" }}>
                        <h5>About {project.organization?.name}</h5>
                    </Box>
                    <p>{project.organization?.description}</p>
                    <Stack direction="column" spacing={1} sx={{ marginBottom: "40px" }}>
                        {project.company?.website && <Box><strong>Website:</strong> <a href={project.organization?.website} target="_blank" rel="noopener noreferrer">{project.company?.website}</a></Box>}
                    </Stack>
                </Box>
                <Box sx={{ flex: "0 1 250px" }}>
                    { (upcomingMeetings?.length ?? 0) > 0 && <MeetingsSidebar /> }
                    <RecentAdvisors advisor={advisor} project={project} />
                </Box>

            </Box>
        </Box>
    );
}